import React from "react"
import UserSearch from "../components/UserSearch"
const UserSearchView = () => {
  return <UserSearch />
}

export default UserSearchView
